import { Navigate, Route, Routes } from 'react-router-dom'
import { useAuth } from 'hooks/auth'
import { isMobileHomeOnly } from 'utils/roles'
import { AuthLayout, MasterLayout } from 'layouts'

import DashboardRoutes from './dashboard'
import AuthRoutes from './auth'
import MailboxPage from './mailbox/MailboxPage'
import RateconFineTuningPage from './ratecon-fine-tuning'
import OraclePage from './crm/CrmPage'
import BrokersRoutes from './brokers/BrokersRoutes'
import LoadPipelineRoutes from './load-pipeline'
import BrokerPipelineRoutes from './broker-pipeline'
import MobileHomeLayoutPage from './dashboard/pages/mobile-home-layout/MobileHomeLayoutPage'
import MobilePromoPagesPage from './dashboard/pages/mobile-promo-pages/MobilePromoPagesPage'

function MobileHomeOnlyRoutes() {
    return (
        <Routes>
            <Route
                path="mobile-home-layout"
                element={
                    <MasterLayout>
                        <MobileHomeLayoutPage />
                    </MasterLayout>
                }
            />
            <Route
                path="mobile-promo-pages"
                element={
                    <MasterLayout>
                        <MobilePromoPagesPage />
                    </MasterLayout>
                }
            />
            <Route path="*" element={<Navigate to="/mobile-home-layout" replace />} />
        </Routes>
    )
}

export default function AppRoutes() {
    const { isAuthenticated } = useAuth()

    if (isAuthenticated && isMobileHomeOnly()) return <MobileHomeOnlyRoutes />

    return (
        <Routes>
            <Route
                path="auth/*"
                element={
                    <AuthLayout>
                        <AuthRoutes />
                    </AuthLayout>
                }
            />
            <Route
                path="ratecon-fine-tuning"
                element={
                    <MasterLayout>
                        <RateconFineTuningPage />
                    </MasterLayout>
                }
            />
            <Route
                path="crm/*"
                element={
                    <MasterLayout>
                        <OraclePage />
                    </MasterLayout>
                }
            />
            <Route
                path="brokers/*"
                element={
                    <MasterLayout>
                        <BrokersRoutes />
                    </MasterLayout>
                }
            />
            <Route
                path="mailbox"
                element={
                    <MasterLayout>
                        <MailboxPage />
                    </MasterLayout>
                }
            />
            <Route
                path="load-pipeline/*"
                element={
                    <MasterLayout>
                        <LoadPipelineRoutes />
                    </MasterLayout>
                }
            />
            <Route
                path="broker-pipeline/*"
                element={
                    <MasterLayout>
                        <BrokerPipelineRoutes />
                    </MasterLayout>
                }
            />
            <Route
                path="*"
                element={
                    <MasterLayout>
                        <DashboardRoutes />
                    </MasterLayout>
                }
            />
        </Routes>
    )
}
